import {
    AuthenticatedTemplate,
    UnauthenticatedTemplate,
  } from "@azure/msal-react";
   
  import Typography from "@mui/material/Typography";
   
  
  import { productViewModel } from "../api";
  import { useState } from "react";
import { PackingComponent } from "../ui-components/PackingComponent";
   
  
   
  
  export function Packing() {
    const [formdata, setformdata] = useState<productViewModel | null>(null);
    function resetdata(data?: productViewModel) {
      console.log("form data returned");
      console.log(data);
      if (data === undefined)   
      setformdata(data);
    }
    return (
      <>
        <AuthenticatedTemplate>
        
         <PackingComponent></PackingComponent>
         
        </AuthenticatedTemplate>
  
        <UnauthenticatedTemplate>
          <Typography variant="h6" align="center">
            Please sign-in to see your profile information.
          </Typography>
        </UnauthenticatedTemplate>
      </>
    );
  }
  